import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpXsrfTokenExtractor,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class TokenAuth implements HttpInterceptor {

  cookieService = inject(CookieService);

  constructor(
    private router: Router,
    private cookieExtractor: HttpXsrfTokenExtractor,
    public authService: AuthService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

  const token = this.authService.getToken();

  // ❗ Skip token for login API
  if (request.url.includes('/api/accounts/login/')) {
    return next.handle(request);
  }

  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      },
      withCredentials: true   // ✅ Send cookies also
    });
  } else {
    request = request.clone({
      withCredentials: true   // still send cookies
    });
  }

  return next.handle(request).pipe(
    catchError((error: HttpErrorResponse) => {

      if (error.status === 401) {
        localStorage.clear();
        this.router.navigate(['auth/login']);
      }

      return throwError(() => error);
    })
  );
}
}